import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import VoucherListComponent from "./views/VoucherList";

const VoucherList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <VoucherListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Voucher Report",
          description: "voucher report section"
        })}
      />
      <Routes>
        <Route path={""} element={<VoucherList />} />
      </Routes>
    </>
  );
};

export default Component;
